// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".seller-contact-information-wrapper[data-v-63883cee]{display:grid;grid-template-columns:repeat(auto-fit,minmax(400px,1fr))}", ""]);
// Exports
module.exports = exports;
